import * as React from "react";
import CreateSelect from "react-select/creatable";
import { SelectOptions, TableSelectProps } from "../Table.types";

export function TableSelect({
  onBlur,
  isMulti,
  options,
  onChange,
  placeholder,
  defaultValue,
  onInputChange,
  onCreateOptions,
  value: valueProp,
  closeMenuOnSelect,
  defaultInputValue
}: TableSelectProps<SelectOptions>) {
  const [value, setValue] = React.useState<
    SelectOptions | SelectOptions[] | undefined
  >(valueProp);
  const [updatedOptions, setUpdatedOptions] = React.useState<SelectOptions[]>(
    options!
  );
  const selectOptions = typeof options === 'function' ? options() : Array.isArray(options) ? options : undefined;

  function createOption(label: string) {
    return {
      label,
      value: label.toLowerCase().replace(/\W/g, "")
    };
  }

  function handleChange(newValue: any, actionMeta: any) {
    setValue(newValue);
    onChange && onChange(newValue);
  }

  function handleInputChange(inputValue: any, actionMeta: any) {
    onInputChange && onInputChange(inputValue);
  }

  function handleCreateOption(inputValue: any) {
    const newOption = createOption(inputValue);
    const newOptions = updatedOptions
      ? [...updatedOptions, newOption]
      : [newOption];
    const newValue = Array.isArray(value) ? [...value, newOption] : newOption;
    const newValueString = Array.isArray(newValue)
      ? newValue.map((item: SelectOptions) => item.value)
      : newValue.value;
    setValue(newValue);
    setUpdatedOptions(newOptions);
    onChange && onChange(newValue);
    onCreateOptions && onCreateOptions(newOptions, newValueString);
  }

  const styles = {
    control: (styles: any) => ({
      ...styles,
      border: "none",
      boxShadow: "none"
    }),
    multiValue: (styles: any) => ({
      ...styles,
      backgroundColor: "#edf2f7"
    }),

    multiValueRemove: (styles: any) => ({
      ...styles,
      ":hover": {
        cursor: "pointer",
        backgroundColor: "#e2e8f0"
      }
    }),
    option: (styles: any, { isSelected }: any) => ({
      ...styles,
      cursor: "pointer",
      padding: "0.2rem 0.5rem",
      color: isSelected ? "#ffffff" : "#333333",
      backgroundColor: isSelected ? "#805ad5" : "transparent",
      "&:hover": {
        color: isSelected ? "#ffffff" : "#333333",
        backgroundColor: isSelected ? "#805ad5" : "#f7fafc"
      }
    }),
    indicatorsContainer: () => ({
      display: "none"
    })
  };

  return (
    <CreateSelect
      isClearable
      value={value}
      styles={styles}
      onBlur={onBlur}
      isMulti={isMulti}
      options={selectOptions!}
      onChange={handleChange}
      placeholder={placeholder}
      aria-label="table-select"
      defaultValue={defaultValue}
      onInputChange={handleInputChange}
      onCreateOption={handleCreateOption}
      defaultInputValue={defaultInputValue}
      closeMenuOnSelect={closeMenuOnSelect}
    />
  );
}
